<template>
  <path
    d="M4 18.0002H8C8.55 18.0002 9 17.5502 9 17.0002C9 16.4502 8.55 16.0002 8 16.0002H4C3.45 16.0002 3 16.4502 3 17.0002C3 17.5502 3.45 18.0002 4 18.0002ZM3 7.00018C3 7.55018 3.45 8.00018 4 8.00018H20C20.55 8.00018 21 7.55018 21 7.00018C21 6.45018 20.55 6.00018 20 6.00018H4C3.45 6.00018 3 6.45018 3 7.00018ZM4 13.0002H14C14.55 13.0002 15 12.5502 15 12.0002C15 11.4502 14.55 11.0002 14 11.0002H4C3.45 11.0002 3 11.4502 3 12.0002C3 12.5502 3.45 13.0002 4 13.0002Z"
  />
</template>
